import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cc04c2c2"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc04c2c2')) {
      api.createRecord('cc04c2c2', component.options)
    } else {
      api.reload('cc04c2c2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cc04c2c2", function () {
      api.rerender('cc04c2c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Mask/index.vue"
export default component.exports